import { render, staticRenderFns } from "./LayoutBackoffice.vue?vue&type=template&id=79d39c9d&"
import script from "./LayoutBackoffice.vue?vue&type=script&lang=js&"
export * from "./LayoutBackoffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports